module.exports = __webpack_public_path__ + "assets/img/logitech-landingpage-and-website-internal-w540.17978b03.webp";